import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackViewedAsset } from "@air/analytics";
import { Portal } from "@air/primitive-portal";
import { useShortIdContext } from "@air/provider-short-id";
import { memo, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AssetModal } from "~/components/AssetModal/AssetModal";
import { usePublicSSOAssetCallback } from "~/components/PublicSSOCallback/usePublicSSOAssetCallback";
import { usePublicWorkspace } from "~/components/PublicWorkspaceProvider";
import { useURLClipIdSelector } from "~/hooks/useURLClipIdSelector";
import { VideoTimeFormatProvider } from "~/providers/VideoTimeFormatProvider";
import { clearCentralizedClipAction, setCentralizedClipAction } from "~/store/centralizedClip/actions";
import { centralizedClipAssetIdSelector, centralizedClipIsDemoSelector } from "~/store/centralizedClip/selectors";
import { useGetPublicBoardClip } from "~/swr-hooks/shortUrl/useGetPublicBoardClip";
import { useAirStore } from "~/utils/ReduxUtils";
import { PublicBoardAssetModalDesktopLayout } from "./components/PublicBoardAssetModalDesktopLayout";
import { PublicBoardAssetModalMobileLayout } from "./components/PublicBoardAssetModalMobileLayout";
export const PublicBoardAssetModal = /*#__PURE__*/ memo(()=>{
    const store = useAirStore();
    const assetId = useSelector(centralizedClipAssetIdSelector);
    const { workspaceName } = usePublicWorkspace();
    const dispatch = useDispatch();
    const { shortId } = useShortIdContext();
    const clipId = useURLClipIdSelector();
    const { data: sharedClip } = useGetPublicBoardClip({
        clipId,
        shortId
    });
    const { trackViewedAsset } = useTrackViewedAsset();
    usePublicSSOAssetCallback();
    useEffect(()=>{
        if (sharedClip) {
            dispatch(setCentralizedClipAction({
                clip: {
                    ...sharedClip,
                    boards: []
                }
            }));
        }
    }, [
        sharedClip,
        workspaceName,
        assetId,
        dispatch
    ]);
    useEffect(()=>{
        return ()=>{
            dispatch(clearCentralizedClipAction());
        };
    }, [
        dispatch
    ]);
    useEffect(()=>{
        if (clipId) {
            const assetId = centralizedClipAssetIdSelector(store.getState());
            const isDemo = centralizedClipIsDemoSelector(store.getState());
            trackViewedAsset({
                assetId,
                isDemo,
                clip_id: clipId
            });
        }
    }, [
        clipId,
        store,
        trackViewedAsset
    ]);
    const desktop = useMemo(()=>/*#__PURE__*/ _jsx(PublicBoardAssetModalDesktopLayout, {}), []);
    const mobile = useMemo(()=>/*#__PURE__*/ _jsx(PublicBoardAssetModalMobileLayout, {}), []);
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsx(VideoTimeFormatProvider, {
            clipId: clipId || shortId,
            children: /*#__PURE__*/ _jsx(AssetModal, {
                desktop: desktop,
                mobile: mobile
            })
        })
    });
});
PublicBoardAssetModal.displayName = "PublicBoardAssetModal";
